import {
  AlertDialog as ChakraAlertDialog,
  type AlertDialogProps,
  Drawer as ChakraDrawer,
  type DrawerProps,
  Modal as ChakraModal,
  type ModalProps,
} from '@chakra-ui/react';

/**
 * Chakra locks the page behind an open modal with `react-remove-scroll`, and its
 * `allowPinchZoom` default of `false` makes that lock call `preventDefault()` on
 * every two-finger `touchmove` — pinch-to-zoom is dead for the whole page as long
 * as any modal is open.
 *
 * On iOS that's a trap rather than an inconvenience: Safari still zooms in on its
 * own whenever a sub-16px input is focused, and with the gesture blocked there is
 * no way back out short of reloading the page (AH-2579).
 *
 * Zoom is an accessibility affordance, so it stays on by default; a caller that
 * genuinely needs it off can still pass `allowPinchZoom={false}`.
 *
 * `Drawer` and `AlertDialog` render their own `<Modal>` internally — Chakra's, not
 * this one — so they need the same default applied here.
 */
export const Modal = (props: ModalProps) => (
  <ChakraModal allowPinchZoom {...props} />
);

export const Drawer = (props: DrawerProps) => (
  <ChakraDrawer allowPinchZoom {...props} />
);

export const AlertDialog = (props: AlertDialogProps) => (
  <ChakraAlertDialog allowPinchZoom {...props} />
);
